function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideoOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 25,
    viewBox: "0 0 5.2916669 6.6145836",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "layer1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g868",
    transform: "matrix(0.99964688,0,0,1.0003434,5.2292061e-5,-3.9181804e-5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path21849",
    style: {
      fill: "#c2e7eb",
      fillOpacity: 1,
      stroke: "#343434",
      strokeWidth: "0.313113px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    },
    d: "M 4.0787977,0.11238033 5.1829272,1.0389638 M 0.15026792,0.14899751 H 4.0265153 V 1.0755929 H 5.1306449 V 6.4482938 H 0.15026792 Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g862"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path31591",
    style: {
      fill: "none",
      stroke: "#343434",
      strokeWidth: 0.313607,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeOpacity: 1
    },
    d: "M 1.2096745,3.1140751 H 4.1358477 V 5.3347113 H 1.2096745 Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#343434",
      fillOpacity: 1,
      stroke: "#343434",
      strokeWidth: "0.281433px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    },
    d: "M 2.1276675,3.837169 V 4.7088625 L 3.142917,4.2730157 Z",
    id: "path31593"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoOn);
export default __webpack_public_path__ + "static/media/video_on.f9ea866efea538077ce21af1122e329c.svg";
export { ForwardRef as ReactComponent };